import logo from './logo.svg';
import React, {  useEffect } from 'react';
import axios from 'axios';
import { API_DOMAIN } from './globals'; // Import the global domain name

function Login() {
    const baseURL = `${API_DOMAIN}/getClientLoginStatus.php`;
    const [username, setUsername] = React.useState("");  //state
    const [password, setPassword] = React.useState("");
    const [msg, setMessage] = React.useState("");

    const handelInput = (e) => {
        switch (e.target.id) {
            case "username":
                setUsername(e.target.value)
                break;
            case "password":
                setPassword(e.target.value)
                break;

            default:
                break;
        }
    }
    const changeSubmit = (e) => {
        e.preventDefault()
        

        fetch(baseURL, {
            method: 'POST',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: username,
                password: password,
            }),
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.Status === "Success") {
                // setMessage(data.Message + ", Success");
                sessionStorage.setItem('UserType', data.UType);
                sessionStorage.setItem('UserName', data.UName);
                sessionStorage.setItem('ClientCode', data.ClientCode);
                sessionStorage.setItem('ClientName', data.ClientName);
                sessionStorage.setItem('Coins', data.Coins);
                sessionStorage.setItem('Exposure', data.Exposure);
                sessionStorage.setItem('UserTypeDisp_client', "CLIENT");
                sessionStorage.setItem("LogoutMsg","");
                sessionStorage.setItem("TNCDisp","Yes");

                //console.log("UserType="+data.UType+", UserName="+data.UName);

                if(data.ChangePassword=="No")
                    window.location = '/Dashboard';
                else
                    window.location = '/ChangePasswordAFL';
            } else {
                setMessage(data.Message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });

    }

    useEffect(() => {

        setMessage(sessionStorage.getItem("LogoutMsg"));

    }, []);

    
    return (


        <div className="login_container">
            <div className="login_wrapper-bg" style={{ background: 'linear-gradient(#622569,#622569)' }}>
                <div className="lazy-container-login" id="wrapper" style={{ background: 'linear-gradient(#4d0355ff,#4d0355ff)' }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ color: 'rgb(255, 255, 255)', fontSize: '22px', fontWeight: 'bold'}}>
                            <img src="images/run99.png" alt="..." style={{ height: '60px', width: '110px' }} />  
                        </div>
                    </div>
                    <div id="App" className="form">
                        <section className="App_content">
                            
                            <form  id="login-form" onSubmit={changeSubmit} method="post">
                            {/* <form id="App-form" method="post"> */}
                                <input type="hidden" name="compute" value="013177c69564abc2bd92a4dd77c4c554" />
                                <div className="input_box">
                                    <i className="fas fa-user"></i>
                                    <input type="text" id="username" onChange={handelInput} placeholder="Username" required="" />
                                    {/* <input type="text" id="username" placeholder="Username" required="" /> */}
                                </div>
                                <div className="input_box">
                                    <i className="fas fa-lock"></i>
                                    <input type="password" id="password" onChange={handelInput} placeholder="Password" required="" />
                                </div>
                                <div className="clearfix"></div>
                                <span style={{ color: 'white', textAlign: 'center' }}>
                                    {msg}
                                </span>
                                <div>
                                    <button type="submit" className="btn btn-success submit">Log in <i className="fas fa-sign-in-alt"></i>
                                    </button>
                                </div>
                            </form>
                            
                        </section>
                    </div>
                </div>
            </div>
        </div>


    );
}

export default Login;
